import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { createQueryKey } from '@hero/utils';

import * as services from '../../services';

export const useGetLLMSuggestionsGiftMessage = (body, options) => {
  return useQuery({
    queryKey: createQueryKey(QUERY_KEYS.useGetLLMSuggestionsGiftMessageKey, body),
    queryFn: async () => {
      const response = await services.getLLMSuggestionsGiftMessage(body);
      return response;
    },
    ...options
  });
};
